export const en: Record<string, string> = {
  // Navigation
  dashboard: 'Dashboard',
  clients: 'Clients',
  treatments: 'Treatments',
  reports: 'Reports',
  settings: 'Settings',
  billing: 'Billing',
  team: 'Team',
  locations: 'Locations',
  signOut: 'Sign Out',
  saasPlatform: 'Klijentli SaaS Platform',
  
  // User Roles
  roleAdmin: 'Admin',
  roleManager: 'Manager',
  roleTherapist: 'Therapist',
  roleReceptionist: 'Receptionist',
  
  // Dashboard Customizer
  customizeDashboard: 'Customize Dashboard',
  visibleWidgets: 'Visible Widgets',
  hiddenWidgets: 'Hidden Widgets',
  statisticsCards: 'Statistics Cards',
  statisticsCardsDescription: 'Total clients, treatments, revenue, and more',
  quickActions: 'Quick Actions',
  quickActionsDescription: 'Shortcuts to common tasks',
  recentVisits: 'Recent Visits',
  recentVisitsDescription: 'Latest completed treatments',
  upcomingAppointments: 'Upcoming Appointments',
  upcomingAppointmentsDescription: 'Scheduled visits in the next 7 days',
  layoutOptions: 'Layout Options',
  statisticsGridColumns: 'Statistics Grid Columns',
  column: 'Column',
  columns: 'Columns',
  resetToDefaults: 'Reset to Defaults',
  saveChanges: 'Save Changes',
  saving: 'Saving...',
  hide: 'Hide',
  show: 'Show',
  moveUp: 'Move up',
  moveDown: 'Move down',
  failedToSavePreferences: 'Failed to save preferences. Please try again.',
  
  // Role Manager
  users: 'Users',
  userRolesAndPermissions: 'User Roles & Permissions',
  manageUserRolesAndPermissions: 'Manage user roles and permissions for your organization',
  organizationMembers: 'Organization Members',
  rolePermissionsOverview: 'Role Permissions Overview',
  roleDescriptions: 'Role Descriptions',
  clientManagement: 'Client Management',
  treatmentManagement: 'Treatment Management',
  userManagement: 'User Management',
  reportsAndSettings: 'Reports & Settings',
  organizationAndFinancial: 'Organization & Financial',
  viewColon: 'View:',
  createColon: 'Create:',
  editColon: 'Edit:',
  deleteColon: 'Delete:',
  manageRolesColon: 'Manage Roles:',
  viewReportsColon: 'View Reports:',
  exportReportsColon: 'Export Reports:',
  viewSettingsColon: 'View Settings:',
  editSettingsColon: 'Edit Settings:',
  manageLocationsColon: 'Manage Locations:',
  viewFinancialsColon: 'View Financials:',
  manageBillingColon: 'Manage Billing:',
  subscriptionColon: 'Subscription:',
  roleAdminDescription: 'Full access to all features. Can manage subscription, billing, locations, and all organizational aspects. Has automatic access to all company locations.',
  roleManagerDescription: 'Location management and oversight. Can manage staff at their location, view reports, and handle day-to-day operations. Cannot manage subscription or other locations.',
  roleTherapistDescription: 'Clinical access with limited administrative functions. Can view and create clients and treatments, but cannot delete records or manage users.',
  roleReceptionistDescription: 'Front desk operations. Can view clients, create appointments, and schedule treatments. Limited editing capabilities.',
  adminLocationAccess: 'Admin Location Access',
  adminLocationAccessDescription: 'Admin users have automatic access to all locations in their organization, even without explicit location_access records. This ensures administrators can always manage and oversee all organizational operations.',
  
  // Invitation Form
  inviteTeamMember: 'Invite Team Member',
  sendInvitationToJoinTeam: 'Send an invitation to join your team',

  // Dashboard Page
  welcomeBack: 'Welcome back',
  heresWhatsHappeningAt: "Here's what's happening at",
  today: 'today',
  customize: 'Customize',
  totalClients: 'Total Clients',
  activeClientsInYourClinic: 'Active clients in your clinic',
  treatmentsCompletedThisMonth: 'Treatments completed this month',
  availableTreatmentTypes: 'Available treatment types',
  revenue: 'Revenue',
  totalRevenueThisMonth: 'Total revenue this month',
  addClient: 'Add Client',
  createNewClientProfile: 'Create a new client profile',
  scheduleTreatment: 'Schedule Treatment',
  bookNewTreatmentSession: 'Book a new treatment session',
  viewReports: 'View Reports',
  checkYourBusinessAnalytics: 'Check your business analytics',
  manageTreatments: 'Manage Treatments',
  configureTreatmentTypes: 'Configure treatment types',
  recentActivity: 'Recent Activity',
  recentVisitsTitle: 'Recent Visits',
  upcomingAppointmentsTitle: 'Upcoming Appointments',
  unknownClient: 'Unknown Client',
  noTherapistAssigned: 'No therapist assigned',
  noRecentActivity: 'No recent activity',
  startByAddingFirstClient: 'Start by adding your first client or scheduling a treatment.',

  // Treatments Page
  manageYourSkincaretreatmentsAndSessions: 'Manage your skincare treatments and sessions',
  allTreatmentSessions: 'All treatment sessions',
  noTreatmentsFound: 'No treatments found',
  startBySchedulingYourFirstTreatment: 'Start by scheduling your first treatment.',
  addTreatment: 'Add Treatment',
  searchTreatments: 'Search treatments...',
  searchTreatmentsByClientOrType: 'Search by client or treatment type...',
  allCategories: 'All categories',
  completed: 'Completed',
  scheduled: 'Scheduled',
  cancelled: 'Cancelled',
  sortByDate: 'Sort by date',
  sortByName: 'Sort by name',
  sortByPrice: 'Sort by price',
  sortByDuration: 'Sort by duration',
  ascending: 'Ascending',
  descending: 'Descending',
  client: 'Client',
  treatmentType: 'Treatment Type',
  treatmentDate: 'Treatment Date',
  duration: 'Duration',
  treatmentCost: 'Treatment Cost',
  status: 'Status',
  actions: 'Actions',
  minutes: 'min',
  deleteTreatment: 'Delete Treatment',
  deleteTreatmentConfirmation: 'Are you sure you want to delete this treatment?',
  deleteTreatmentWarning: 'This action cannot be undone.',
  treatmentDeleted: 'Treatment deleted successfully',
  failedToDelete: 'Failed to delete',
  previous: 'Previous',
  next: 'Next',
  showing: 'Showing',
  to: 'to',
  of: 'of',
  results: 'results',
  errorLoadingTreatments: 'Error loading treatments',
  viewTreatment: 'View Treatment',
  tryAgain: 'Try Again',
  tryAdjustingYourSearchTerms: 'Try adjusting your search terms',
  types: 'types',
  
  // Treatment Types Page
  manageTreatmentTypes: 'Manage treatment types',
  addTreatmentType: 'Add Treatment Type',
  search: 'Search',
  searchTreatmentTypes: 'Search treatment types...',
  sortBy: 'Sort by',
  order: 'Order',
  noTreatmentTypes: 'No treatment types',
  noTreatmentTypesMessage: 'Get started by creating your first treatment type.',
  cost: 'Cost',
  notSpecified: 'Not specified',
  deleteConfirmation: 'Delete Confirmation',
  deleteTreatmentTypeConfirmation: 'Are you sure you want to delete this treatment type? This action cannot be undone.',
  treatmentTypeDeleted: 'Treatment type deleted successfully',
  loading: 'Loading...',
  close: 'Close',
  
  // Treatment Type Translations (common types)
  // These are dynamic translations based on treatment type names from the database
  // Format: treatmentType_{normalizedName} where normalizedName is lowercase with spaces replaced by underscores
  
  // Treatment Page View Modes
  treatmentsHistory: 'Treatments History',
  calendarView: 'Calendar View',
  appointmentsList: 'Appointments List',
  newAppointment: 'New Appointment',
  appointmentSavedSuccessfully: 'Appointment saved successfully',
  therapistHasConflict: 'Therapist has a conflict at this time',
  appointmentRescheduled: 'Appointment rescheduled',
  failedToRescheduleAppointment: 'Failed to reschedule appointment',
  appointmentDurationUpdated: 'Appointment duration updated',
  failedToUpdateAppointmentDuration: 'Failed to update appointment duration',
  month: 'Month',
  week: 'Week',
  day: 'Day',
  
  // Treatment Page Filters
  allTherapists: 'All Therapists',
  allStatuses: 'All Statuses',
  startDate: 'Start Date',
  endDate: 'End Date',
  resetFilters: 'Reset Filters',
  confirmed: 'Confirmed',
  noShow: 'No Show',
  
  // Appointment Modal
  editAppointment: 'Edit Appointment',
  client: 'Client',
  therapist: 'Therapist',
  treatmentTypes: 'Treatment Types',
  startTime: 'Start Time',
  durationMinutes: 'Duration (minutes)',
  title: 'Title',
  optionalAppointmentTitle: 'Optional appointment title',
  notes: 'Notes',
  additionalNotes: 'Additional notes...',
  pleaseFillRequiredFields: 'Please fill in all required fields',
  therapistHasConflict: 'Therapist has a conflicting appointment at this time',
  appointmentCreatedSuccessfully: 'Appointment created successfully',
  appointmentUpdatedSuccessfully: 'Appointment updated successfully',
  failedToSaveAppointment: 'Failed to save appointment',
  noTreatmentTypesAvailable: 'No treatment types available',
  treatmentTypeSelected: 'treatment type selected',
  treatmentTypesSelected: 'treatment types selected',
  createRecurringAppointment: 'Create recurring appointment',
  pattern: 'Pattern',
  every: 'Every',
  daysOfWeek: 'Days of Week',
  endDateOptional: 'End Date (optional)',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  create: 'Create',
  update: 'Update',
  cancel: 'Cancel',
  minutes: 'min',
  createAppointment: 'Create Appointment',
  updateAppointment: 'Update Appointment',
  
  // Days of week (abbreviated)
  sun: 'Sun',
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',

  // Locations Page
  manageLocations: 'Manage locations',
  addLocation: 'Add Location',
  searchLocation: 'Search locations...',
  sortByAddress: 'Sort by address',
  editLocation: 'Edit Location',
  editLocationDescription: 'Update location information',
  updateLocation: 'Update Location',
  backToLocations: 'Back to locations',
  activeLocationDescription: 'Inactive locations will not be available for selection',
  addLocationDescription: 'Create a new location for your business',
  failedToLoadLocation: 'Failed to load location',
  locationCreated: 'Location created successfully',
  locationUpdated: 'Location updated successfully',
  failedToCreate: 'Failed to create',
  failedToUpdate: 'Failed to update',
  nameRequired: 'Name is required',
  invalidEmail: 'Invalid email address',
  pleaseFixErrors: 'Please fix the errors in the form',
  noPermissionToManageLocations: "You don't have permission to manage locations",
  loadingLocationData: 'Loading location data...',
  basicInformation: 'Basic Information',
  name: 'Name',
  enterLocationName: 'Enter location name',
  address: 'Address',
  enterAddress: 'Enter full address',
  contactInformation: 'Contact Information',
  phone: 'Phone',
  enterPhone: 'Enter phone number',
  email: 'Email',
  enterEmail: 'Enter email address',
  active: 'Active',
  updating: 'Updating...',
  creating: 'Creating...',
  createLocation: 'Create Location',
  searchLocations: 'Search locations...',
  locationDeleted: 'Location deleted successfully',
  location: 'Location',
  contact: 'Contact',
  inactive: 'Inactive',
  noLocations: 'No locations found',
  noLocationsMessage: 'Get started by creating your first location',
  deleteLocationConfirmation: 'Are you sure you want to delete this location? This action cannot be undone.',

  // Company Settings Page
  companySettings: 'Company Settings',
  manageCompanyInformationBrandingAndSubscription: 'Manage your company information, branding, and subscription details',
  editSettings: 'Edit Settings',
  companyInformation: 'Company Information',
  basicInformationAboutYourCompanyOrClinic: 'Basic information about your company or clinic',
  companyName: 'Company Name',
  enterCompanyName: 'Enter company name',
  website: 'Website',
  enterCompanyAddress: 'Enter company address',
  description: 'Description',
  briefDescriptionOfYourCompanyOrClinic: 'Brief description of your company or clinic',
  branding: 'Branding',
  customizeYourCompanysVisualIdentity: "Customize your company's visual identity",
  primaryColor: 'Primary Color',
  secondaryColor: 'Secondary Color',
  subscription: 'Subscription',
  manageYourSubscriptionPlanAndBilling: 'Manage your subscription plan and billing',
  currentPlan: 'Current Plan',
  trialEnds: 'Trial Ends',
  changePlan: 'Change Plan',
  billingHistory: 'Billing History',
  teamManagement: 'Team Management',
  manageTeamMembersAndTheirRoles: 'Manage team members and their roles',
  totalUsers: 'Total Users',
  activeUsers: 'Active Users',
  viewAllUsers: 'View All Users',
  analyticsAndReports: 'Analytics & Reports',
  viewCompanyPerformanceAndAnalytics: 'View company performance and analytics',
  thisMonthRevenue: 'This Month Revenue',
  activeClients: 'Active Clients',
  appointmentsThisMonth: 'Appointments This Month',
  viewDetailedReports: 'View Detailed Reports',
  exportData: 'Export Data',

  // Profile Page
  profile: 'Profile',
  manageYourPersonalInformationAndAccountSettings: 'Manage your personal information and account settings',
  personalInformation: 'Personal Information',
  editProfile: 'Edit Profile',
  profileUpdatedSuccessfully: 'Profile updated successfully!',
  failedToUpdateProfile: 'Failed to update profile. Please try again.',
  firstName: 'First Name',
  lastName: 'Last Name',
  firstNameRequired: 'First name is required',
  lastNameRequired: 'Last name is required',
  firstNameMinLength: 'First name must be at least 2 characters',
  lastNameMinLength: 'Last name must be at least 2 characters',
  enterYourFirstName: 'Enter your first name',
  enterYourLastName: 'Enter your last name',
  emailAddress: 'Email Address',
  emailRequired: 'Email is required',
  invalidEmailAddress: 'Invalid email address',
  enterYourEmailAddress: 'Enter your email address',
  phoneNumber: 'Phone Number',
  enterYourPhoneNumber: 'Enter your phone number',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  currentPasswordRequired: 'Current password is required',
  newPasswordRequired: 'New password is required',
  confirmPasswordRequired: 'Please confirm your new password',
  passwordMinLength: 'Password must be at least 8 characters',
  passwordsDoNotMatch: 'Passwords do not match',
  enterYourCurrentPassword: 'Enter your current password',
  enterYourNewPassword: 'Enter your new password',
  confirmYourNewPassword: 'Confirm your new password',

  // Clients Page
  allClients: 'All Clients',
  manageClientsFromAllYourAccessibleLocations: 'Manage clients from all your accessible locations',
  errorLoadingClients: 'Error loading clients',
  tryAgain: 'Try Again',
  manageYourSkincareClientsAndTheirInformation: 'Manage your skincare clients and their information',
  searchClientsByNameEmailOrPhone: 'Search clients by name, email or phone',
  lastVisit: 'Last Visit',
  totalSpent: 'Total Spent',
  view: 'View',
  grid: 'Grid',
  list: 'List',
  showingXOfYClients: 'Showing {{x}} of {{y}} clients',
  showingXClients: 'Showing {{x}} clients',
  noClientsFound: 'No clients found',
  noClientsYet: "You don't have any clients yet",
  tryAdjustingYourSearchTerms: 'Try adjusting your search terms',
  getStartedByAddingYourFirstClient: 'Get started by adding your first client',
  yearsOld: 'yrs old',
  visits: 'visits',
  viewClient: 'View client',
  deleteClient: 'Delete client',
  deleteClientConfirmation: 'Are you sure you want to delete this client? This action cannot be undone.',

  // Client Form
  back: 'Back',
  clientDetails: 'Client Details',
  editClient: 'Edit Client',
  profilePicture: 'Profile Picture',
  personalInformation: 'Personal Information',
  firstName: 'First Name',
  lastName: 'Last Name',
  enterFirstName: 'Enter first name',
  enterLastName: 'Enter last name',
  dateOfBirth: 'Date of Birth',
  enterAddress: 'Enter address',
  enterEmail: 'Enter email',
  enterPhone: 'Enter phone',
  emergencyContact: 'Emergency Contact',
  emergencyContactName: 'Emergency contact name',
  emergencyPhone: 'Emergency Phone',
  emergencyPhoneNumber: 'Emergency phone number',
  skinInformation: 'Skin Information',
  selectSkinType: 'Select skin type',
  describeSkinConcerns: 'Describe skin concerns',
  medicalInformation: 'Medical Information',
  medicalHistory: 'Medical History',
  relevantMedicalHistory: 'Relevant medical history',
  listAllergies: 'List allergies',
  medications: 'Medications',
  currentMedications: 'Current medications',
  additionalInformation: 'Additional Information',
  additionalNotes: 'Additional notes',
  clientPreferences: 'Client preferences',
  updating: 'Updating...',
  creating: 'Creating...',
  updateClient: 'Update Client',
  createClient: 'Create Client',
  clientCreated: 'Client created',
  clientUpdated: 'Client updated',
  firstNameRequired: 'First name is required',
  lastNameRequired: 'Last name is required',
  invalidPhone: 'Invalid phone number',
  invalidEmergencyPhone: 'Invalid emergency phone number',
  saveClientFirstBeforeUploadingPhoto: 'Please save the client first before uploading a photo',
  loadingClientData: 'Loading client data...',
  
  // Skin Types
  normal: 'Normal',
  dry: 'Dry',
  oily: 'Oily',
  combination: 'Combination',
  sensitive: 'Sensitive',
  acneProne: 'Acne-prone',
  mature: 'Mature',

  // Client Detail
  failedToLoadClient: 'Failed to load client',
  clientDeleted: 'Client deleted',
  confirmDeleteClient: 'Are you sure you want to delete this client?',
  clientNotFound: 'Client Not Found',
  clientNotFoundMessage: 'The client you are looking for was not found or does not exist.',
  backToClients: 'Back to Clients',
  clientId: 'Client ID',
  memberSince: 'Member Since',
  lastUpdated: 'Last Updated',
  unknown: 'Unknown',
  none: 'None',
  clientNotes: 'Client Notes',
  noNotes: 'No notes',

  // Common actions
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  save: 'Save',
  cancel: 'Cancel',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  search: 'Search',
  filter: 'Filter',
  sort: 'Sort',
  view: 'View',
  close: 'Close',
  loading: 'Loading...',
  noData: 'No data',
  actions: 'Actions',
  contact: 'Contact',
  lastVisit: 'Last visit',
  quickActions: 'Quick actions',
  name: 'Name',
  description: 'Description',
  basicInformation: 'Basic information',

  // Client related
  clientId: 'Client ID',
  addClient: 'Add client',
  editClient: 'Edit client',
  newClient: 'New client',
  clientDetails: 'Client details',
  clientForm: 'Client form',
  manageClients: 'Manage your skincare clients and their information',
  personalInformation: 'Personal information',
  contactInformation: 'Contact information',
  skinInformation: 'Skin information',
  medicalInformation: 'Medical information',
  additionalInformation: 'Additional information',

  // Client fields
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email',
  phone: 'Phone',
  dateOfBirth: 'Date of birth',
  address: 'Address',
  emergencyContact: 'Emergency contact',
  emergencyPhone: 'Emergency phone',
  skinType: 'Skin type',
  skinConcerns: 'Skin concerns',
  medicalHistory: 'Medical history',
  allergies: 'Allergies',
  medications: 'Medications',
  notes: 'Notes',
  preferences: 'Preferences',

  // Skin types
  normal: 'Normal',
  dry: 'Dry',
  oily: 'Oily',
  combination: 'Combination',
  sensitive: 'Sensitive',
  acneProne: 'Acne prone',
  mature: 'Mature',

  // Treatment related
  addTreatment: 'Add treatment',
  editTreatment: 'Edit treatment',
  newTreatment: 'New treatment',
  treatmentDetails: 'Treatment details',
  treatmentType: 'Treatment type',
  treatmentDate: 'Treatment date',
  treatmentCost: 'Treatment cost',
  treatmentNotes: 'Treatment notes',
  time: 'Time',
  and: 'and',
  noTime: 'No time',
  timeWillBeRoundedToNearest10Minutes: 'Time will be rounded to the nearest 10 minutes',
  lastTreatmentDate: 'Last treatment',
  treatmentCount: 'treatment count',
  addNewTreatment: 'Add new treatment',
  selectClient: 'Select client',
  selectTreatmentType: 'Select treatment type',
  duration: 'Duration (min)',
  therapist: 'Therapist',
  selectTherapist: 'Select therapist',
  noTherapistsFound: 'No therapists found',
  clearSelection: 'Clear selection',
  status: 'Status',
  completed: 'Completed',
  scheduled: 'Scheduled',
  cancelled: 'Cancelled',
  observations: 'Observations',
  measurements: 'Measurements',
  products: 'Products',
  homecare: 'Home care',
  followUpDate: 'Follow-up date',
  required: 'is required',
  invalid: 'is invalid',
  manageTreatments: 'Manage your skincare treatments',
  searchTreatments: 'Search treatments...',
  allCategories: 'All categories',
  facial: 'Facial',
  peel: 'Peel',
  resurfacing: 'Resurfacing',
  therapy: 'Therapy',
  sortByName: 'Sort by name',
  sortByPrice: 'Sort by price',
  sortByDuration: 'Sort by duration',
  sortByDate: 'Sort by date',
  treatment: 'Treatment',
  category: 'Category',
  price: 'Price',
  active: 'Active',
  inactive: 'Inactive',
  deleteTreatment: 'Delete treatment',

  // Treatment Types
  treatmentTypes: 'Treatment types',
  addTreatmentType: 'Add treatment type',
  editTreatmentType: 'Edit treatment type',
  newTreatmentType: 'New treatment type',
  treatmentTypeDetails: 'Treatment type details',
  manageTreatmentTypes: 'Manage treatment types',
  searchTreatmentTypes: 'Search treatment types...',
  treatmentTypeCreated: 'Treatment type created successfully!',
  treatmentTypeUpdated: 'Treatment type updated successfully!',
  treatmentTypeDeleted: 'Treatment type deleted successfully!',
  createTreatmentType: 'Create treatment type',
  updateTreatmentType: 'Update treatment type',
  deleteTreatmentTypeConfirmation: 'Are you sure you want to delete this treatment type?',
  backToTreatmentTypes: 'Back to treatment types',
  editTreatmentTypeDescription: 'Edit treatment type information',
  addTreatmentTypeDescription: 'Add a new treatment type to the system',
  loadingTreatmentTypeData: 'Loading treatment type data...',
  failedToLoadTreatmentType: 'Error loading treatment type',
  noTreatmentTypes: 'No treatment types',
  noTreatmentTypesMessage: 'Start by adding your first treatment type.',
  pricingAndDuration: 'Pricing and duration',
  minutes: 'minutes',
  enterTreatmentTypeName: 'Enter treatment type name',
  enterTreatmentTypeDescription: 'Enter treatment type description',
  enterDuration: 'Enter duration',
  enterCost: 'Enter cost',
  nameRequired: 'Name is required',
  invalidDuration: 'Invalid duration',
  invalidCost: 'Invalid cost',
  selectCategory: 'Select category',
  antiaging: 'Anti-aging',
  acne: 'Acne',
  sortByCategory: 'Sort by category',

  // Dashboard
  welcome: 'Welcome',
  overview: 'Overview',
  recentActivity: 'Recent activity',
  upcomingAppointments: 'Upcoming appointments',
  totalClients: 'Total clients',
  totalTreatments: 'Total treatments',
  monthlyRevenue: 'Monthly revenue',
  dashboardThisMonth: 'This month',
  dashboardLastMonth: 'Last month',
  createNewClientProfile: 'Create a new client profile',
  scheduleNewTreatment: 'Schedule a new treatment',
  recordTreatment: 'Record treatment',
  logNewTreatmentSession: 'Log a new treatment session',
  viewReports: 'View reports',
  checkBusinessAnalytics: 'Check business analytics',
  toGlow: 'to Glow',
  yourSkincareClientManagementSystem: 'your skincare client management system',
  addNewClient: 'Add a new client',
  configureServices: 'Configure services',

  // Reports
  revenueReport: 'Revenue report',
  clientReport: 'Client report',
  treatmentReport: 'Treatment report',
  dateRange: 'Date range',
  generateReport: 'Generate report',
  export: 'Export',
  filtersAndDateRange: 'Filters & Date Range',
  filterReportsByDateClientsAndMore: 'Filter reports by date, clients, therapists, and treatment types',
  quickRanges: 'Quick Ranges',
  last3Days: 'Last 3 Days',
  last7Days: 'Last 7 Days',
  last30Days: 'Last 30 Days',
  last90Days: 'Last 90 Days',
  filterByClient: 'Filter by Client',
  filterByTherapist: 'Filter by Therapist',
  filterByTreatmentType: 'Filter by Treatment Type',
  allTreatmentTypes: 'All Treatment Types',
  sortByClient: 'Sort by Client',
  sortByTherapist: 'Sort by Therapist',
  sortByCost: 'Sort by Cost',
  treatmentTypeBreakdown: 'Treatment Type Breakdown',
  distributionOfTreatmentsByType: 'Distribution of treatments by type',
  exportOptions: 'Export Options',
  downloadReportInVariousFormats: 'Download report in various formats',
  exportCSV: 'Export CSV',
  exportJSON: 'Export JSON',
  exportPDF: 'Export PDF',
  print: 'Print',
  treatmentDetails: 'Treatment Details',
  noDataAvailable: 'No data available',
  tryAdjustingFilters: 'Try adjusting your filters or date range',
  exportSuccess: 'Report exported successfully',
  exportFailed: 'Failed to export report',

  // Settings
  generalSettings: 'General settings',
  userProfile: 'User profile',
  security: 'Security',
  languagePreferences: 'Language Preferences',
  selectYourPreferredLanguage: 'Select your preferred language for the application',
  language: 'Language',
  currentLanguage: 'Current language',
  manageYourApplicationPreferencesAndConfiguration: 'Manage your application preferences and configuration',
  dashboardCustomization: 'Dashboard Customization',
  customizeYourDashboardLayoutAndWidgets: 'Customize your dashboard layout and widgets',
  customizeDashboard: 'Customize Dashboard',
  dataManagement: 'Data Management',
  exportAndImportYourClinicSettings: 'Export and import your clinic settings',
  exportSettings: 'Export Settings',
  importSettings: 'Import Settings',
  dataRetentionDays: 'Data Retention (days)',
  enableAnalytics: 'Enable Analytics',
  collectUsageAnalytics: 'Collect usage analytics',
  systemInformation: 'System Information',
  applicationAndSystemDetails: 'Application and system details',
  version: 'Version',
  environment: 'Environment',
  development: 'Development',
  databaseStatus: 'Database Status',
  connected: 'Connected',
  saveSettings: 'Save Settings',

  // Messages
  clientCreated: 'Client created successfully!',
  clientUpdated: 'Client updated successfully!',
  clientDeleted: 'Client deleted successfully!',
  treatmentCreated: 'Treatment created successfully!',
  treatmentUpdated: 'Treatment updated successfully!',
  treatmentDeleted: 'Treatment deleted successfully!',
  failedToCreate: 'Failed to create',
  failedToUpdate: 'Failed to update',
  failedToDelete: 'Failed to delete',
  pleaseFixErrors: 'Please fix errors in the form',

  // Validation messages
  firstNameRequired: 'First name is required',
  lastNameRequired: 'Last name is required',
  invalidEmail: 'Please enter a valid email address',
  invalidPhone: 'Please enter a valid phone number (e.g., 061 123 4567)',
  invalidEmergencyPhone: 'Please enter a valid emergency phone number (e.g., 061 123 4567)',

  // Placeholders
  enterFirstName: 'Enter first name',
  enterLastName: 'Enter last name',
  enterEmail: 'Enter email address',
  enterPhone: 'Enter phone number (e.g., 061 123 4567)',
  enterAddress: 'Enter address',
  emergencyContactName: 'Emergency contact name',
  emergencyPhoneNumber: 'Emergency phone number (e.g., 061 123 4567)',
  selectSkinType: 'Select skin type',
  describeSkinConcerns: 'Describe skin concerns',
  relevantMedicalHistory: 'Relevant medical history',
  listAllergies: 'List allergies',
  currentMedications: 'Current medications',
  additionalNotes: 'Additional notes about the client',
  clientPreferences: 'Client treatment preferences',

  // Search and filters
  searchClients: 'Search clients...',
  allSkinTypes: 'All skin types',
  sortBy: 'Sort by',
  order: 'Order',
  ascending: 'Ascending',
  descending: 'Descending',
  dateAdded: 'Date added',

  // Pagination
  showing: 'Showing',
  to: 'to',
  of: 'of',
  results: 'results',
  perPage: 'per page',

  // Status and badges
  notSpecified: 'Not specified',
  noTreatments: 'No treatments',
  added: 'Added',
  updated: 'Updated',
  created: 'Created',
  none: 'None',
  unknown: 'Unknown',
  noVisits: 'No visits',
  noNotes: 'No notes',
  clientNotFound: 'Client not found',
  clientNotFoundMessage: 'The client you are looking for does not exist.',
  backToClients: 'Back to clients',
  confirmDeleteClient: 'Are you sure you want to delete this client? This action cannot be undone.',
  failedToLoadClient: 'Error loading client',
  totalVisits: 'Total visits',
  memberSince: 'Member since',
  treatmentHistory: 'Treatment history',
  clientNotes: 'Client notes',
  cost: 'Cost',
  date: 'Date',

  // Confirmation dialogs
  deleteConfirmation: 'Delete confirmation',
  deleteClientConfirmation: 'Are you sure you want to delete',
  deleteClientWarning: 'This action cannot be undone and will delete all associated treatments and photos.',
  deleteTreatmentConfirmation: 'Are you sure you want to delete this treatment?',
  deleteTreatmentWarning: 'This action cannot be undone.',

  // Loading states
  loadingClientData: 'Loading client data...',
  creating: 'Creating...',
  updating: 'Updating...',
  deleting: 'Deleting...',

  // Error messages
  somethingWentWrong: 'Something went wrong',
  errorMessage: 'We apologize, but an unexpected error occurred. Please try refreshing the page.',
  refreshPage: 'Refresh page',
  error: 'Error',
  failedToLoadTreatment: 'Error loading treatment',
  treatmentNotFound: 'Treatment not found',
  treatmentNotFoundMessage: 'The treatment you are looking for does not exist.',
  backToTreatments: 'Back to treatments',

  // Form actions
  createClient: 'Create client',
  updateClient: 'Update client',
  createTreatment: 'Create treatment',
  updateTreatment: 'Update treatment',
  lastUpdated: 'Last updated',
  // Statistics
  statistics: 'Statistics',
  totalSpent: 'Total spent',
  averageTreatmentCost: 'Average treatment cost',
  firstTreatment: 'First treatment',
  uniqueTreatmentTypes: 'Unique treatment types',
  treatmentBreakdown: 'Treatment breakdown',
  in: 'in',
  revenue: 'Revenue',

  // Quick search
  quickSearch: 'Quick search',
  searchPlaceholder: 'Search by name, last name, email or phone...',

  // Empty states
  noClientsFound: 'No clients found',
  noClientsMessage: 'Try adjusting your search or filters.',
  noClientsEmptyMessage: 'Start by adding your first client.',
  noTreatmentsFound: 'No treatments found',
  noTreatmentsMessage: 'Try adjusting your search or filters.',
  noTreatmentsEmptyMessage: 'Start by adding your first treatment.',

  // Photo gallery
  photos: 'Photos',
  addPhoto: 'Add photo',
  uploadPhoto: 'Upload photo',
  photoDate: 'Photo date',
  photoNotes: 'Photo notes',

  // Calendar and dates
  today: 'Today',
  yesterday: 'Yesterday',
  thisWeek: 'This week',
  calendarThisMonth: 'This month',
  calendarLastMonth: 'Last month',
  dateFormat: 'MM/dd/yyyy',
  timeFormat: 'hh:mm a',

  // Notifications
  markAsRead: 'Mark as read',
  markAllAsRead: 'Mark all as read',
  noNotifications: 'No new notifications',

  // User profile
  profile: 'Profile',
  accountSettings: 'Account settings',
  changePassword: 'Change password',
  logout: 'Logout',
  login: 'Login',
  register: 'Register',

  // Help and support
  help: 'Help',
  support: 'Support',
  documentation: 'Documentation',
  contactSupport: 'Contact support',
  feedback: 'Feedback',

  // System messages
  systemMaintenance: 'System maintenance',
  maintenanceMessage: 'The system is currently under maintenance. Please try again later.',
  sessionExpired: 'Session expired',
  sessionExpiredMessage: 'Your session has expired. Please log in again.',
  networkError: 'Network error',
  networkErrorMessage: 'A network error occurred. Please check your internet connection.',

  // Reports
  viewAnalyticsAndGenerateReports: 'View analytics and generate reports',
  monthlyTrends: 'Monthly trends',
  revenueTrends: 'Revenue trends',
  activeClients: 'Active clients',
  averageRevenuePerClient: 'Average revenue per client',
  averageCost: 'Average cost',
  uniqueClients: 'Unique clients',
  averageRevenuePerPeriod: 'Average revenue per period',
  refresh: 'Refresh',
  lastTreatment: 'Last treatment',

  // Success messages
  success: 'Success',
  operationCompleted: 'Operation completed successfully',
  dataSaved: 'Data saved successfully',
  changesApplied: 'Changes applied successfully',

  // Warning messages
  warning: 'Warning',
  unsavedChanges: 'You have unsaved changes',
  unsavedChangesMessage: 'Are you sure you want to leave the page? Unsaved changes will be lost.',
  leavePage: 'Leave page',
  stayOnPage: 'Stay on page',

  // Clients Page
  allClients: 'All Clients',
  manageClientsFromAllYourAccessibleLocations: 'Manage clients from all your accessible locations',
  errorLoadingClients: 'Error Loading Clients',
  tryAgain: 'Try Again',
  manageYourSkincareClientsAndTheirInformation: 'Manage your skincare clients and their information',
  addClient: 'Add Client',
  searchClientsByNameEmailOrPhone: 'Search clients by name, email, or phone...',
  lastVisit: 'Last Visit',
  totalSpent: 'Total Spent',
  view: 'View',
  grid: 'Grid',
  list: 'List',
  showingXOfYClients: 'Showing {{x}} of {{y}} clients',
  showingXClients: 'Showing {{x}} clients',
  noClientsFound: 'No clients found',
  noClientsYet: 'No clients yet',
  tryAdjustingYourSearchTerms: 'Try adjusting your search terms.',
  getStartedByAddingYourFirstClient: 'Get started by adding your first client.',
  yearsOld: 'years old',
  visits: 'visits',
  viewClient: 'View client',
  deleteClient: 'Delete client',
  deleteClientConfirmation: 'Are you sure you want to delete this client? This action cannot be undone.',
  unknownClient: 'Unknown Client',

  // Documentation Page
  documentationTitle: 'Documentation',
  documentationSubtitle: 'Complete guide to using Klijentli',
  backToDashboard: 'Back to Dashboard',
  tableOfContents: 'Table of Contents',
  needMoreHelp: 'Need More Help?',
  needMoreHelpMessage: "Can't find what you're looking for? Contact your system administrator or reach out to support for assistance.",
  goToDashboard: 'Go to Dashboard',
  selectLanguage: 'Select Language',
  
  // Documentation Sections
  docGettingStarted: 'Getting Started',
  docClientManagement: 'Client Management',
  docTreatmentManagement: 'Treatment Management',
  docTreatmentTypes: 'Treatment Types Catalog',
  docPhotoManagement: 'Photo Management',
  docReportsAnalytics: 'Reports & Analytics',
  docTeamManagement: 'Team Management',
  docSettings: 'Settings & Preferences',
  docWorkflows: 'Common Workflows',
  docTipsBestPractices: 'Tips & Best Practices',
  
  // Documentation Content - Getting Started
  docWelcomeToGlowCenter: 'Welcome to Klijentli',
  docWelcomeDescription: 'Klijentli is a comprehensive client management system designed specifically for skincare professionals, estheticians, dermatologists, and beauty clinics. This platform helps you manage clients, track treatments, store photos, and analyze your business performance.',
  docLoggingIn: 'Logging In',
  docNavigateToLogin: 'Navigate to the login page at /login',
  docEnterEmailPassword: 'Enter your email address and password',
  docClickSignIn: 'Click "Sign In" to access your account',
  docSelectLocation: 'If you have access to multiple locations, select your working location',
  docDashboardOverview: 'Dashboard Overview',
  docDashboardAfterLogin: 'After logging in, you\'ll see your personalized dashboard displaying:',
  docQuickStats: 'Quick stats: Total clients, today\'s appointments, revenue',
  docRecentClientActivity: 'Recent client activity',
  docUpcomingAppointments: 'Upcoming appointments',
  docPerformanceMetrics: 'Performance metrics and trends',
  docNavigation: 'Navigation',
  docUseSidebarMenu: 'Use the sidebar menu to navigate between different sections:',
  docNavDashboard: 'Dashboard 📊 - Your main overview and statistics',
  docNavClients: 'Clients 👥 - Manage client profiles and information',
  docNavTreatments: 'Treatments 🏥 - Record and track treatment sessions',
  docNavTreatmentTypes: 'Treatment Types 🎯 - Manage your service catalog',
  docNavReports: 'Reports 📈 - Analytics and business insights',
  docNavTeam: 'Team 👨‍💼 - Manage team members and permissions',
  docNavSettings: 'Settings ⚙️ - Configure your preferences',
  
  // Documentation Content - Client Management
  docAddingNewClient: 'Adding a New Client',
  docNavigateToClients: 'Navigate to Clients from the sidebar menu',
  docClickAddClient: 'Click the "Add Client" button in the top-right corner',
  docFillClientForm: 'Fill in the client information form:',
  docPersonalDetails: 'Personal details (name, email, phone, date of birth)',
  docContactInfo: 'Contact information and address',
  docEmergencyContact: 'Emergency contact details',
  docClickSave: 'Click "Save" to create the client profile',
  docClientProfileInfo: 'Client Profile Information',
  docEachClientProfile: 'Each client profile contains:',
  docBasicInfo: 'Basic Information - Name, contact details, demographics',
  docSkinAssessment: 'Skin Assessment - Skin type (normal, oily, dry, combination, sensitive)',
  docMedicalHistory: 'Medical History - Allergies, medications, medical conditions',
  docTreatmentHistory: 'Treatment History - Complete record of all treatments',
  docPhotoGallery: 'Photo Gallery - Before/after photos with date tracking',
  docNotes: 'Notes - Custom notes and preferences',
  docEditingClientInfo: 'Editing Client Information',
  docGoToClientsList: 'Go to the Clients list and find the client',
  docClickClientName: 'Click on the client\'s name to view their profile',
  docClickEdit: 'Click the "Edit" button',
  docUpdateInfo: 'Update the necessary information',
  docClickSaveChanges: 'Click "Save Changes"',
  docSkinAssessmentSection: 'Skin Assessment',
  docDocumentSkinInfo: 'Document detailed skin information including:',
  docSkinType: 'Skin Type - Normal, oily, dry, combination, or sensitive',
  docSkinConcerns: 'Skin Concerns - Acne, aging, pigmentation, sensitivity, etc.',
  docAllergies: 'Allergies - Product allergies and sensitivities',
  docCurrentMedications: 'Current Medications - Relevant medications affecting treatments',
  docSearchingFilteringClients: 'Searching and Filtering Clients',
  docUseSearchBar: 'Use the search bar at the top of the Clients page to quickly find clients by name, email, or phone number. The search updates in real-time as you type.',
  
  // Documentation Content - Treatment Management
  docRecordingTreatmentSession: 'Recording a Treatment Session',
  docNavigateToTreatments: 'Navigate to Treatments from the sidebar',
  docClickNewTreatment: 'Click "New Treatment" button',
  docSelectClient: 'Select the client from the dropdown menu',
  docChooseTreatmentType: 'Choose the treatment type from your catalog',
  docFillTreatmentDetails: 'Fill in treatment details:',
  docDateAndTime: 'Date and time of treatment',
  docDuration: 'Duration',
  docPrice: 'Price (auto-filled from treatment type)',
  docTherapistPerforming: 'Therapist performing the treatment',
  docAddDetailedNotes: 'Add detailed notes and observations',
  docClickSaveTreatment: 'Click "Save Treatment"',
  docTreatmentDocumentation: 'Treatment Documentation',
  docComprehensiveRecords: 'Comprehensive treatment records should include:',
  docObservations: 'Observations - Current skin condition, concerns addressed',
  docProductsUsed: 'Products Used - List all products applied during treatment',
  docTechniques: 'Techniques - Methods and approaches used',
  docClientFeedback: 'Client Feedback - How the client responded to treatment',
  docPhotos: 'Photos - Before and after treatment photos',
  docHomecareInstructions: 'Homecare Instructions - Post-treatment care recommendations',
  docNextSteps: 'Next Steps - Recommended follow-up treatments and timeline',
  docViewingTreatmentHistory: 'Viewing Treatment History',
  docOpenClientProfile: 'Open a client\'s profile from the Clients page',
  docScrollToTreatmentHistory: 'Scroll to the "Treatment History" section',
  docViewPastTreatments: 'View all past treatments in chronological order',
  docClickTreatment: 'Click on any treatment to view full details',
  docCompareProgress: 'Compare progress over time with photos and notes',
  docProgressTracking: 'Progress Tracking',
  docTrackClientProgress: 'Track client progress by comparing treatment sessions over time. Review photos, notes, and observations to measure treatment effectiveness and adjust care plans accordingly.',
  docEditingDeletingTreatments: 'Editing or Deleting Treatments',
  docToModifyTreatment: 'To modify a treatment record:',
  docNavigateToTreatment: 'Navigate to the treatment from the Treatments list or client profile',
  docClickEditButton: 'Click the "Edit" button',
  docMakeChanges: 'Make your changes',
  docNotePermissions: 'Note: Only users with appropriate permissions can edit or delete treatment records.',
  
  // Documentation Content - Treatment Types
  docManagingTreatmentTypes: 'Managing Treatment Types',
  docTreatmentTypesDescription: 'Treatment Types are your service catalog - the different treatments and services you offer. Setting these up properly ensures consistency and accurate pricing.',
  docCreatingNewTreatmentType: 'Creating a New Treatment Type',
  docNavigateToTreatmentTypes: 'Navigate to Treatment Types from the sidebar',
  docClickAddTreatmentType: 'Click "Add Treatment Type"',
  docFillTreatmentInfo: 'Fill in the treatment information:',
  docNameExample: 'Name - e.g., "Deep Cleansing Facial"',
  docDescription: 'Description - Detailed description of the treatment',
  docDurationMinutes: 'Duration - Typical treatment duration in minutes',
  docPrice: 'Price - Standard pricing for this treatment',
  docCategory: 'Category - Optional categorization (Facials, Peels, Laser, etc.)',
  docClickSaveToAdd: 'Click "Save" to add to your catalog',
  docCommonTreatmentCategories: 'Common Treatment Categories',
  docOrganizeServices: 'Organize your services into categories such as:',
  docFacials: 'Facials - Deep cleansing, hydrating, anti-aging facials',
  docChemicalPeels: 'Chemical Peels - Light, medium, and deep peels',
  docLaserTreatments: 'Laser Treatments - Hair removal, resurfacing, etc.',
  docMicroneedling: 'Microneedling - Collagen induction therapy',
  docInjectables: 'Injectables - Botox, fillers, etc.',
  docBodyTreatments: 'Body Treatments - Body wraps, scrubs, etc.',
  docSpecializedTreatments: 'Specialized Treatments - Custom or specialty services',
  docEditingTreatmentTypes: 'Editing Treatment Types',
  docUpdateTreatmentDetails: 'You can update treatment details, pricing, or descriptions at any time. Changes won\'t affect historical treatment records, ensuring accurate historical data.',
  docBestPractices: 'Best Practices',
  docKeepNamesConsistent: 'Keep treatment names clear and consistent',
  docIncludeDetailedDescriptions: 'Include detailed descriptions for staff reference',
  docUpdatePricesRegularly: 'Update prices regularly to reflect current rates',
  docUseCategories: 'Use categories to organize your catalog',
  docSetRealisticDuration: 'Set realistic duration times for scheduling',
  
  // Documentation Content - Photo Management
  docUploadingPhotos: 'Uploading Photos',
  docOpenClientProfileOrTreatment: 'Open a client\'s profile or treatment record',
  docNavigateToPhotos: 'Navigate to the "Photos" section',
  docClickUploadPhoto: 'Click "Upload Photo" or drag and drop images',
  docAddPhotoDetails: 'Add photo details:',
  docPhotoType: 'Photo Type - Before, After, Progress, or Reference',
  docBodyArea: 'Body Area - Face, neck, hands, etc.',
  docAngle: 'Angle - Front, left, right, top view',
  docDate: 'Date - When the photo was taken',
  docNotes: 'Notes - Additional context or observations',
  docPhotoOrganization: 'Photo Organization',
  docPhotosAutoOrganized: 'Photos are automatically organized by:',
  docDateChronological: 'Date - Chronological timeline of client progress',
  docTreatmentSession: 'Treatment Session - Photos linked to specific treatments',
  docType: 'Type - Before/after comparisons',
  docBodyAreaGrouped: 'Body Area - Grouped by treatment area',
  docBeforeAfterComparisons: 'Before/After Comparisons',
  docCreateCompellingComparisons: 'Create compelling before/after comparisons:',
  docNavigateToPhotoGallery: 'Navigate to the client\'s photo gallery',
  docSelectBeforePhoto: 'Select a "Before" photo from the timeline',
  docClickCompare: 'Click "Compare"',
  docSelectAfterPhoto: 'Select the corresponding "After" photo',
  docViewSideBySide: 'View side-by-side comparison',
  docOptionallySave: 'Optionally save or export the comparison',
  docPhotoBestPractices: 'Photo Best Practices',
  docUseConsistentLighting: 'Use consistent lighting for accurate comparisons',
  docSameAngles: 'Take photos from the same angles each time',
  docEnsureConsent: 'Ensure client consent before taking photos',
  docCloseUpAndWide: 'Take both close-up and wider angle shots',
  docNaturalLighting: 'Photograph in natural lighting when possible',
  docTagImmediately: 'Tag photos immediately with accurate metadata',
  docHighQuality: 'Use high-quality images (but within size limits)',
  docStorageAndPrivacy: 'Storage and Privacy',
  docPhotosSecurelyStored: 'All photos are securely stored and encrypted. Access is restricted to authorized team members only. Photos are automatically backed up and can be exported if needed for client records.',
  docSupportedFileFormats: 'Supported File Formats',
  docSupportedFormats: 'Supported formats: JPEG, PNG, WebP. Maximum file size: 10MB per photo.',
  
  // Documentation Content - Reports & Analytics
  docDashboardMetrics: 'Dashboard Metrics',
  docDashboardProvides: 'Your dashboard provides real-time insights into your business:',
  docTotalClients: 'Total Clients - Current active client count',
  docRevenueTrends: 'Revenue Trends - Daily, weekly, monthly revenue',
  docTreatmentStatistics: 'Treatment Statistics - Popular treatments and frequency',
  docClientActivity: 'Client Activity - New clients, returning clients',
  docGrowthMetrics: 'Growth Metrics - Month-over-month comparisons',
  docViewingReports: 'Viewing Reports',
  docNavigateToReports: 'Navigate to Reports from the sidebar',
  docSelectReportType: 'Select a report type or date range',
  docViewCharts: 'View interactive charts and graphs',
  docFilterByLocation: 'Filter by location, therapist, or treatment type',
  docExportReports: 'Export reports to PDF or Excel for further analysis',
  docAvailableReports: 'Available Reports',
  docRevenueReport: 'Revenue Report - Income breakdown by period',
  docTreatmentAnalysis: 'Treatment Analysis - Most popular services',
  docClientRetention: 'Client Retention - Return rates and loyalty metrics',
  docTherapistPerformance: 'Therapist Performance - Individual staff statistics',
  docGrowthTrends: 'Growth Trends - Long-term business growth',
  docClientDemographics: 'Client Demographics - Age, location, preferences',
  docUsingAnalyticsForGrowth: 'Using Analytics for Growth',
  docLeverageData: 'Leverage your data to make informed business decisions:',
  docIdentifyProfitable: 'Identify your most profitable treatments',
  docTrackRetention: 'Track client retention and re-engagement needs',
  docMonitorProductivity: 'Monitor therapist productivity and workload',
  docSpotSeasonalTrends: 'Spot seasonal trends in your business',
  docMeasureMarketing: 'Measure marketing campaign effectiveness',
  docSetGoals: 'Set goals and track progress toward targets',
  docExportingData: 'Exporting Data',
  docAllReportsExportable: 'All reports can be exported in various formats (PDF, Excel, CSV) for presentations, accounting purposes, or deeper analysis in external tools.',
  
  // Documentation Content - Team Management
  docInvitingTeamMembers: 'Inviting Team Members',
  docNavigateToTeam: 'Navigate to Team from the sidebar',
  docClickInviteTeamMember: 'Click "Invite Team Member"',
  docEnterTeamMemberInfo: 'Enter the team member\'s information:',
  docEmailAddress: 'Email address',
  docFirstLastName: 'First and last name',
  docRole: 'Role (Admin, Manager, Therapist, Receptionist)',
  docLocationAccess: 'Location access (which locations they can access)',
  docClickSendInvitation: 'Click "Send Invitation"',
  docMemberReceivesEmail: 'The team member will receive an email with setup instructions',
  docUserRolesAndPermissions: 'User Roles and Permissions',
  docDifferentRoles: 'Different roles have different access levels:',
  docAdmin: 'Admin - Full access to all features and settings',
  docAdminManageCompany: 'Manage company settings and billing',
  docAdminCreateLocations: 'Create and manage all locations',
  docAdminInviteMembers: 'Invite and manage all team members',
  docAdminAccessReports: 'Access all reports and analytics',
  docManager: 'Manager - Location management and oversight',
  docManagerManageLocations: 'Manage assigned locations',
  docManagerInviteMembers: 'Invite team members to their locations',
  docManagerViewReports: 'View location reports and analytics',
  docManagerManagePricing: 'Manage treatment types and pricing',
  docTherapist: 'Therapist - Day-to-day treatment operations',
  docTherapistAddClients: 'Add and manage clients',
  docTherapistRecordTreatments: 'Record treatments',
  docTherapistUploadPhotos: 'Upload and manage photos',
  docTherapistViewPerformance: 'View their own performance data',
  docReceptionist: 'Receptionist - Front desk operations',
  docReceptionistViewClients: 'View client information',
  docReceptionistSchedule: 'Schedule appointments',
  docReceptionistLimitedEditing: 'Limited editing capabilities',
  docManagingLocationAccess: 'Managing Location Access',
  docForMultiLocation: 'For multi-location businesses:',
  docOpenTeamMemberProfile: 'Open the team member\'s profile',
  docNavigateToLocationAccess: 'Navigate to "Location Access" section',
  docSelectLocations: 'Select which locations they can access',
  docSaveChanges: 'Save changes',
  docDataIsolation: 'Team members can only view and manage data for their assigned locations, ensuring proper data isolation.',
  docEditingTeamMembers: 'Editing Team Members',
  docToModifyRole: 'To modify a team member\'s role or access, click on their name in the Team list, make the necessary changes, and click "Save Changes". Changes take effect immediately.',
  docRemovingTeamMembers: 'Removing Team Members',
  docWhenRemoving: 'When removing a team member, their access is immediately revoked. Historical data they created (treatments, notes, etc.) remains in the system for record-keeping purposes.',
  
  // Documentation Content - Settings
  docUserSettings: 'User Settings',
  docCustomizePreferences: 'Customize your personal preferences:',
  docProfileInformation: 'Profile Information - Update your name, email, phone',
  docProfilePicture: 'Profile Picture - Upload a profile photo',
  docLanguage: 'Language - Choose your preferred language (English, Serbian)',
  docNotifications: 'Notifications - Configure email and in-app notifications',
  docPassword: 'Password - Change your account password',
  docDashboardLayout: 'Dashboard Layout - Customize your dashboard widgets',
  docCompanySettings: 'Company Settings',
  docAdminOnly: '(Admin only) Configure company-wide settings:',
  docCompanyInfo: 'Company Information - Name, address, contact details',
  docBranding: 'Branding - Logo, colors, and visual identity',
  docBusinessHours: 'Business Hours - Operating hours for each location',
  docDefaultSettings: 'Default Settings - System-wide defaults for treatments, pricing',
  docIntegrations: 'Integrations - Connect third-party services',
  docLocationSettings: 'Location Settings',
  docConfigureLocation: 'Configure individual location settings:',
  docLocationDetails: 'Location Details - Address, phone, email',
  docStaffAssignment: 'Staff Assignment - Which team members work at this location',
  docOperatingHours: 'Operating Hours - Business hours for this location',
  docTreatmentAvailability: 'Treatment Availability - Services offered at this location',
  docNotificationPreferences: 'Notification Preferences',
  docControlNotifications: 'Control what notifications you receive:',
  docNewAppointmentNotifications: 'New appointment notifications',
  docTreatmentReminders: 'Treatment reminders',
  docTeamActivityAlerts: 'Team member activity alerts',
  docSystemUpdates: 'System updates and announcements',
  docSummaryReports: 'Weekly/monthly summary reports',
  docLanguageSelection: 'Language Selection',
  docGlowCenterSupports: 'Klijentli supports multiple languages. Change your language preference in Settings → User Preferences. The interface will update immediately to your selected language.',
  docDataExportAndBackup: 'Data Export and Backup',
  docAdminOnlyExport: '(Admin only) Export your data for backup or migration purposes. All client records, treatments, and photos can be exported in standard formats.',
  
  // Documentation Content - Workflows
  docCompleteClientOnboarding: 'Complete Client Onboarding',
  docCreateNewProfile: 'Create new client profile with personal information',
  docCompleteSkinAssessment: 'Complete skin assessment and medical history',
  docTakeInitialPhotos: 'Take initial "before" photos from multiple angles',
  docDiscussGoals: 'Discuss treatment goals and create plan',
  docRecordFirstTreatment: 'Record first treatment session',
  docScheduleFollowUp: 'Schedule follow-up appointments',
  docSendHomecare: 'Send homecare instructions',
  docTreatmentSessionWorkflow: 'Treatment Session Workflow',
  docOpenClientProfile: 'Open client profile from dashboard or client list',
  docReviewPrevious: 'Review previous treatment notes and photos',
  docTakeBeforePhotos: 'Take "before treatment" photos if needed',
  docCreateTreatmentRecord: 'Create new treatment record',
  docSelectTreatmentType: 'Select treatment type from catalog',
  docPerformDocument: 'Perform and document the treatment',
  docTakeAfterPhotos: 'Take "after treatment" photos',
  docAddDetailedNotes: 'Add detailed notes and observations',
  docProvideHomecare: 'Provide homecare instructions',
  docScheduleNext: 'Schedule next appointment',
  docProcessPayment: 'Process payment (if applicable)',
  docWeeklyReviewProcess: 'Weekly Review Process',
  docReviewMetrics: 'Review dashboard metrics and trends',
  docCheckAppointments: 'Check upcoming appointments for the week',
  docFollowUpClients: 'Follow up with clients who haven\'t returned',
  docReviewQuestions: 'Review and respond to team member questions',
  docUpdateTreatmentTypes: 'Update treatment types or pricing if needed',
  docExportWeeklyReports: 'Export weekly reports for analysis',
  docMonthlyBusinessReview: 'Monthly Business Review',
  docGenerateRevenueReport: 'Generate monthly revenue report',
  docReviewRetention: 'Review client retention metrics',
  docAnalyzePopularity: 'Analyze treatment popularity and profitability',
  docReviewPerformance: 'Review team member performance',
  docIdentifyTrends: 'Identify trends and opportunities',
  docSetGoals: 'Set goals for the upcoming month',
  docPlanMarketing: 'Plan marketing or promotional activities',
  docNewTeamMemberSetup: 'New Team Member Setup',
  docSendInvitation: 'Send invitation with appropriate role',
  docAssignLocation: 'Assign location access',
  docCompleteProfile: 'Have them complete their profile',
  docProvideTraining: 'Provide training on the platform',
  docReviewWorkflows: 'Review key workflows together',
  docMonitorActivity: 'Monitor their initial activity',
  docAdjustPermissions: 'Adjust permissions as needed',
  
  // Documentation Content - Tips & Best Practices
  docDataEntryTips: 'Data Entry Tips',
  docEnterNotesImmediately: 'Enter treatment notes immediately after sessions while details are fresh',
  docUseConsistentTerminology: 'Use consistent terminology across all records',
  docBeDetailedConcise: 'Be detailed but concise in observations',
  docAlwaysIncludeCondition: 'Always include skin condition and client feedback',
  docTagPhotosImmediately: 'Tag photos immediately with accurate metadata',
  docPhotoManagementTips: 'Photo Management Tips',
  docConsistentLighting: 'Take photos in consistent lighting conditions',
  docSameAnglesDistances: 'Use the same angles and distances for comparable shots',
  docBeforeAfterEveryTreatment: 'Photograph before and after every significant treatment',
  docStoreDeviceSameLocation: 'Store phone/camera in the same location for consistency',
  docReviewBeforeSaving: 'Review photos before saving to ensure quality',
  docBackupPhotos: 'Back up important photos outside the system as well',
  docClientCommunication: 'Client Communication',
  docKeepCommunicationNotes: 'Keep all client communication notes in their profile',
  docDocumentPreferences: 'Document client preferences and special requests',
  docSetReminders: 'Set reminders for follow-ups',
  docUseNotesField: 'Use the notes field for important context',
  docMaintainProfessional: 'Maintain professional language in all records',
  docSecurityBestPractices: 'Security Best Practices',
  docAlwaysLogOut: 'Always log out when leaving your workstation',
  docUseStrongPasswords: 'Use strong, unique passwords',
  docNeverShareCredentials: 'Never share login credentials',
  docLockDevice: 'Lock your device when stepping away',
  docReportSuspicious: 'Report any suspicious activity immediately',
  docKeepEmailSecure: 'Keep your email password secure (for password resets)',
  docEfficiencyTips: 'Efficiency Tips',
  docSetUpTemplates: 'Set up treatment type templates for common services',
  docUseSearchFunction: 'Use the search function to quickly find clients',
  docCustomizeDashboard: 'Customize your dashboard to show most relevant metrics',
  docLearnShortcuts: 'Learn keyboard shortcuts for faster navigation',
  docBatchTasks: 'Batch similar tasks together (photo uploads, data entry)',
  docReviewReportsWeekly: 'Review reports weekly to stay on top of trends',
  docClientSatisfaction: 'Client Satisfaction',
  docUseBeforeAfter: 'Use before/after photos to demonstrate progress',
  docKeepDetailedRecords: 'Keep detailed records for consistent care',
  docSetAppointmentReminders: 'Set appointment reminders to reduce no-shows',
  docTrackRespond: 'Track and respond to client concerns promptly',
  docMaintainHistories: 'Maintain complete treatment histories for context',
  docProvideClearInstructions: 'Provide clear homecare instructions after each treatment',
  docBusinessGrowth: 'Business Growth',
  docReviewAnalytics: 'Regularly review your analytics to identify opportunities',
  docTrackProfitable: 'Track which treatments are most profitable',
  docMonitorRetention: 'Monitor client retention rates',
  docIdentifyTrends: 'Identify trends in client concerns and needs',
  docUseDataForMarketing: 'Use data to inform marketing decisions',
  docSetMeasurableGoals: 'Set measurable goals and track progress',
  docTrainingNewStaff: 'Training New Staff',
  docHaveStaffReview: 'Have new staff review this documentation thoroughly',
  docCreatePracticeRecords: 'Create practice client records for training purposes',
  docShadowExperienced: 'Shadow experienced team members initially',
  docStartBasic: 'Start with basic tasks and gradually expand access',
  docProvideFeedback: 'Provide regular feedback during the learning period',
  docEncourageQuestions: 'Encourage questions and document common issues',

  // Photo Management
  photos: 'Photos',
  photoGallery: 'Photo Gallery',
  uploadPhotos: 'Upload Photos',
  uploadPhoto: 'Upload Photo',
  viewPhoto: 'View Photo',
  editPhoto: 'Edit Photo',
  deletePhoto: 'Delete Photo',
  downloadPhoto: 'Download Photo',
  noPhotos: 'No Photos',
  noPhotosYet: 'No photos yet',
  noPhotosFound: 'No photos found',
  photoUploadedSuccessfully: 'Photo uploaded successfully',
  photoUpdatedSuccessfully: 'Photo updated successfully',
  photoDeletedSuccessfully: 'Photo deleted successfully',
  failedToUploadPhoto: 'Failed to upload photo',
  failedToUpdatePhoto: 'Failed to update photo',
  failedToDeletePhoto: 'Failed to delete photo',
  failedToLoadPhotos: 'Failed to load photos',
  failedToLoadImage: 'Failed to load image',
  confirmDeletePhoto: 'Are you sure you want to delete this photo? This action cannot be undone.',
  selectPhotosToUpload: 'Select photos to upload',
  dragAndDropPhotos: 'Drag and drop photos here, or click to browse',
  uploadingPhotos: 'Uploading photos...',
  uploadingPhoto: 'Uploading photo...',
  
  // Photo Types
  photoType: 'Photo Type',
  photoTypeBefore: 'Before',
  photoTypeAfter: 'After',
  photoTypeProgress: 'Progress',
  photoTypeReference: 'Reference',
  photoTypeGeneral: 'General',
  
  // Body Areas
  bodyArea: 'Body Area',
  bodyAreaFace: 'Face',
  bodyAreaForehead: 'Forehead',
  bodyAreaEyes: 'Eyes',
  bodyAreaCheeks: 'Cheeks',
  bodyAreaNose: 'Nose',
  bodyAreaLips: 'Lips',
  bodyAreaChin: 'Chin',
  bodyAreaNeck: 'Neck',
  bodyAreaChest: 'Chest',
  bodyAreaHands: 'Hands',
  bodyAreaArms: 'Arms',
  bodyAreaLegs: 'Legs',
  bodyAreaBack: 'Back',
  bodyAreaFullBody: 'Full Body',
  bodyAreaOther: 'Other',
  
  // Photo Angles
  photoAngle: 'Photo Angle',
  angleFront: 'Front View',
  angleLeft: 'Left Side',
  angleRight: 'Right Side',
  angleBack: 'Back View',
  angleTop: 'Top View',
  angleBottom: 'Bottom View',
  angleCloseUp: 'Close-up',
  angleWide: 'Wide Angle',
  angleOther: 'Other',
  
  // Photo Metadata
  photoDetails: 'Photo Details',
  photoMetadata: 'Photo Metadata',
  takenDate: 'Taken Date',
  dateTaken: 'Date Taken',
  photoTitle: 'Photo Title',
  photoDescription: 'Photo Description',
  associatedTreatment: 'Associated Treatment',
  noTreatmentSelected: 'No treatment selected',
  selectTreatment: 'Select Treatment',
  allTreatments: 'All Treatments',
  noDate: 'No date',
  
  // Photo Gallery
  showingXPhotos: 'Showing {{x}} photos',
  filterPhotos: 'Filter Photos',
  sortPhotos: 'Sort Photos',
  sortByNewestFirst: 'Newest First',
  sortByOldestFirst: 'Oldest First',
  sortByType: 'By Type',
  sortByTreatment: 'By Treatment',
  allPhotoTypes: 'All Types',
  allBodyAreas: 'All Areas',
  viewFullSize: 'View Full Size',
  comparisonMode: 'Comparison Mode',
  selectForComparison: 'Select for Comparison',
  exitComparisonMode: 'Exit Comparison Mode',
  
  // Before/After Comparison
  beforeAfterComparison: 'Before/After Comparison',
  comparePhotos: 'Compare Photos',
  selectTwoPhotos: 'Select two photos to compare',
  selectBeforePhoto: 'Select Before Photo',
  selectAfterPhoto: 'Select After Photo',
  beforePhoto: 'Before Photo',
  afterPhoto: 'After Photo',
  exportComparison: 'Export Comparison',
  resetComparison: 'Reset Comparison',
  
  // Photo Validation
  invalidFileType: 'Invalid file type. Only JPEG, PNG, and WebP are allowed.',
  fileTooLarge: 'File size too large. Maximum 10MB allowed.',
  selectAtLeastOnePhoto: 'Please select at least one photo',
  
  // Photo Actions
  photoActions: 'Photo Actions',
  bulkActions: 'Bulk Actions',
  selectPhotos: 'Select Photos',
  selectedXPhotos: '{{x}} photos selected',
  deleteSelectedPhotos: 'Delete Selected Photos',
  downloadSelectedPhotos: 'Download Selected Photos',
  confirmDeleteMultiplePhotos: 'Are you sure you want to delete {{count}} photos? This action cannot be undone.',
  
  // Empty States
  getStartedByUploadingPhotos: 'Get started by uploading your first photo.',
  uploadYourFirstPhoto: 'Upload your first photo to track client progress.',
  noPhotosMatchingFilters: 'No photos match your current filters.',
  tryChangingFilters: 'Try changing your filters or uploading new photos.',
  
  // Photo Info
  photoCount: 'Photo Count',
  recentPhotos: 'Recent Photos',
  viewAllPhotos: 'View All Photos',
  treatmentPhotos: 'Treatment Photos',
  clientPhotos: 'Client Photos',
  clientPhoto: 'Client photo',
  
  // Additional Photo Translations
  noTitle: 'No Title',
  untitled: 'Untitled',
  searchPhotos: 'Search photos...',
  selectBodyArea: 'Select body area',
  selectAngle: 'Select angle',
  enterTitle: 'Enter title',
  enterDescription: 'Enter description',
  supportedFormats: 'Supported formats',
  maxFileSize: 'Max file size',
  ready: 'ready',
  photo: 'photo',
  uploading: 'Uploading...',
  uploadAll: 'Upload All',
  allPhotosUploaded: 'All photos uploaded successfully',
  clearFilters: 'Clear Filters',
  sortBy: 'Sort by',
  saving: 'Saving...',
  saveChanges: 'Save Changes',
  sideBySide: 'Side by Side',
  slider: 'Slider',
  before: 'Before',
  after: 'After',
  uploadedOn: 'Uploaded On',
  selectOneMorePhoto: 'Select one more photo to compare',
  clickToCompare: 'Click below to view comparison',
  retry: 'Retry',
  deleting: 'Deleting...',
  
  // Company Settings
  companySettings: 'Company Settings',
  manageCompanyInformationAndBranding: 'Manage company information and branding',
  companyLogo: 'Company Logo',
  uploadYourCompanyLogo: 'Upload your company logo (recommended: 200x200px, PNG or SVG)',
  companyInformation: 'Company Information',
  basicInformationAboutYourCompanyOrClinic: 'Basic information about your company or clinic',
  companyName: 'Company Name',
  enterCompanyName: 'Enter company name',
  email: 'Email',
  phone: 'Phone',
  address: 'Address',
  enterCompanyAddress: 'Enter company address',
  regionalSettings: 'Regional Settings',
  configureTimezoneDateFormatAndCurrency: 'Configure timezone, date format, and currency',
  timezone: 'Timezone',
  dateFormat: 'Date Format',
  currency: 'Currency',
  branding: 'Branding',
  customizeYourCompanysVisualIdentity: 'Customize your company\'s visual identity',
  primaryColor: 'Primary Color',
  secondaryColor: 'Secondary Color',
  accentColor: 'Accent Color',
  preview: 'Preview',
  primaryButton: 'Primary Button',
  secondaryButton: 'Secondary Button',
  accentButton: 'Accent Button',
  primaryTag: 'Primary Tag',
  secondaryTag: 'Secondary Tag',
  accentTag: 'Accent Tag',
  cardWithPrimaryColor: 'Card with Primary Color',
  thisIsHowYourBrandColorsWillLook: 'This is how your brand colors will appear in various UI elements throughout the application.',
  
  // Logo Upload
  dragAndDropOrClickToUpload: 'Drag and drop or click to upload',
  png_jpg_svg_max2mb: 'PNG, JPG, SVG (max 2MB)',
  changeLogo: 'Change Logo',
  removeLogo: 'Remove Logo',
  removing: 'Removing...',
  uploadingLogo: 'Uploading logo...',
  invalidFileTypeOnlyJpegPngSvgAllowed: 'Invalid file type. Only JPEG, PNG, and SVG are allowed.',
  fileSizeTooLargeMax2mb: 'File size too large. Maximum 2MB allowed.',
  failedToUploadLogo: 'Failed to upload logo',
  failedToRemoveLogo: 'Failed to remove logo',
  settingsUpdatedSuccessfully: 'Settings updated successfully!',
  logoUploadedSuccessfully: 'Logo uploaded successfully!',
  logoRemovedSuccessfully: 'Logo removed successfully!',
  
  // Business Hours
  businessHours: 'Business Hours',
  setTheOperatingHoursForEachLocation: 'Set the operating hours for each location',
  selectLocation: 'Select Location',
  operatingHours: 'Operating Hours',
  setTheBusinessHoursForThisLocation: 'Set the business hours for this location',
  closed: 'Closed',
  open: 'Open',
  close: 'Close',
  to: 'to',
  save: 'Save',
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  pleaseEnterBothOpenAndCloseTimes: 'Please enter both open and close times',
  closeTimeMustBeAfterOpenTime: 'Close time must be after open time',
  failedToSaveBusinessHours: 'Failed to save business hours',
  businessHoursUpdatedSuccessfully: 'Business hours updated successfully!',
  noLocationsFound: 'No locations found',
  pleaseCreateALocationFirst: 'Please create a location first to set business hours.',
  
  // Default Settings
  defaultSettings: 'Default Settings',
  configureDefaultValuesForTreatmentsAndOtherSettings: 'Configure default values for treatments and other settings',
  treatmentDefaults: 'Treatment Defaults',
  defaultValuesForNewTreatments: 'Default values for new treatments',
  defaultTreatmentDurationMinutes: 'Default Treatment Duration (minutes)',
  defaultTreatmentPrice: 'Default Treatment Price',
  requireNotesForTreatments: 'Require Notes for Treatments',
  appointmentDefaults: 'Appointment Defaults',
  defaultValuesForNewAppointments: 'Default values for new appointments',
  defaultAppointmentDurationMinutes: 'Default Appointment Duration (minutes)',
  sendReminderEmail: 'Send Reminder Email',
  reminderTimeHoursBefore: 'Reminder Time (hours before)',
  howManyHoursBeforeAppointmentToSendReminder: 'How many hours before appointment to send reminder',
  defaultSettingsUpdatedSuccessfully: 'Default settings updated successfully!',
  
  // Location Selector
  selectYourLocation: 'Select Your Location',
  chooseLocationWhereYoullBeWorkingToday: 'Choose the location where you\'ll be working today',
  createYourFirstLocationToGetStarted: 'Create your first location to get started.',
  pleaseContactAdministratorForLocationAccess: 'Please contact your administrator to grant you access to a location.',
  createNewLocation: 'Create New Location',
  locationName: 'Location Name',
  locationNamePlaceholder: 'e.g., Main Clinic, Downtown Branch',
  addressPlaceholder: '123 Main St, City, State 12345',
  phonePlaceholder: '(555) 123-4567',
  locationEmailPlaceholder: 'location@example.com',
  failedToSelectLocation: 'Failed to select location',
  failedToCreateLocation: 'Failed to create location',
  
  // Landing Page
  landingSignIn: 'Sign In',
  landingGetStarted: 'Get Started',
  landingHeroTitle: 'Transform Your',
  landingHeroTitleHighlight: 'Practice',
  landingHeroTitleFormal: 'Transform Your Clinic',
  landingHeroDescription: 'The all-in-one platform for professionals. Manage clients, track treatments, store photos, and grow your practice with confidence.',
  landingStartFreeTrial: 'Start Free Trial',
  landingNoCreditCard: 'No credit card required • 14-day free trial • Cancel anytime',
  landingFeaturesTitle: 'Everything You Need to Succeed',
  landingFeaturesSubtitle: 'Powerful tools designed specifically for professionals to manage, track, and grow their practice.',
  landingFeatureClientManagement: 'Client Management',
  landingFeatureClientManagementDesc: 'Organize and track all your clients with detailed profiles, treatment history, and progress photos.',
  landingFeatureTreatmentTracking: 'Treatment Tracking',
  landingFeatureTreatmentTrackingDesc: 'Record treatments, track progress, and maintain detailed notes for each client session.',
  landingFeaturePhotoManagement: 'Photo Management',
  landingFeaturePhotoManagementDesc: 'Store and organize before/after photos with secure cloud storage and easy access.',
  landingFeatureSecureCompliant: 'Secure & Compliant',
  landingFeatureSecureCompliantDesc: 'HIPAA-compliant platform with enterprise-grade security to protect your client data.',
  landingFeatureAppointmentScheduling: 'Appointment Scheduling',
  landingFeatureAppointmentSchedulingDesc: 'Streamline your booking process with integrated scheduling and calendar management.',
  landingFeatureAnalyticsReports: 'Analytics & Reports',
  landingFeatureAnalyticsReportsDesc: 'Gain insights with detailed reports on client progress, revenue, and business metrics.',
  landingBenefitsTitle: 'Why Choose Klijentli?',
  landingBenefitsSubtitle: 'Join thousands of professionals who trust Klijentli to manage their practice and deliver exceptional client experiences.',
  landingBenefitStreamline: 'Streamline your practice',
  landingBenefitSatisfaction: 'Improve client satisfaction',
  landingBenefitProgress: 'Track treatment progress',
  landingBenefitStorage: 'Secure client data storage',
  landingBenefitPhotos: 'Professional photo management',
  landingBenefitAnalytics: 'Detailed analytics and reporting',
  landingResultsTitle: 'Real Results',
  landingResultsClientSatisfaction: 'Client Satisfaction',
  landingResultsTimeSaved: 'Time Saved',
  landingResultsActiveUsers: 'Active Users',
  landingResultsUptime: 'Uptime',
  landingTestimonialsTitle: 'Loved by Professionals',
  landingTestimonialsSubtitle: 'See what professionals are saying about Klijentli',
  landingTestimonial1Content: 'Klijentli has transformed how I manage my practice. The photo tracking feature is incredible for showing client progress.',
  landingTestimonial2Content: 'Finally, a platform that understands professionals. The client management system is intuitive and powerful.',
  landingTestimonial3Content: 'The security and compliance features give me peace of mind. My clients trust that their data is safe.',
  landingCTATitle: 'Ready to Transform Your Practice?',
  landingCTASubtitle: 'Join thousands of professionals who trust Klijentli to manage their practice and deliver exceptional results.',
  landingCTAStartTrial: 'Start Your Free Trial',
  landingFooterDescription: 'The complete platform for professionals.',
  landingFooterProduct: 'Product',
  landingFooterSupport: 'Support',
  landingFooterLegal: 'Legal',
  landingFooterFeatures: 'Features',
  landingFooterPricing: 'Pricing',
  landingFooterSecurity: 'Security',
  landingFooterHelpCenter: 'Help Center',
  landingFooterContact: 'Contact Us',
  landingFooterStatus: 'Status',
  landingFooterPrivacy: 'Privacy Policy',
  landingFooterTerms: 'Terms of Service',
  landingFooterRefund: 'Refund Policy',
  landingFooterHIPAA: 'HIPAA Compliance',
  landingFooterCopyright: '© 2025 Klijentli. All rights reserved.',
  landingFooterPoweredBy: 'Powered by',
  landingLanguageSwitcher: 'Language',
  
  // Cookie Consent
  cookieConsentTitle: 'Cookie Consent',
  cookieConsentDescription: 'We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking "Accept All", you consent to our use of cookies.',
  cookieConsentNecessary: 'Necessary cookies are required for the website to function properly. These cookies cannot be disabled.',
  cookieConsentAnalytics: 'Analytics cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.',
  cookieConsentAdvertising: 'Advertising cookies are used to deliver personalized advertisements and track campaign effectiveness.',
  cookieConsentAcceptAll: 'Accept All',
  cookieConsentRejectAll: 'Reject All',
  cookieConsentSavePreferences: 'Save Preferences',
  cookieConsentCustomize: 'Customize',
  cookieConsentLearnMore: 'Learn More',
};

